module.exports = __webpack_public_path__ + "static/img/android.522140f8.png";